module.exports = __webpack_public_path__ + "static/media/IMG_2066-min.8b0d3c52.JPG";